import React from 'react'
import PropTypes from 'prop-types'
import { FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'

import * as styles from './styles'

const EditSponsorsFormComponent = ({
  header,
  form,
  onSubmitRequest,
  initialValues,
  loadJurisdictions,
  getOptionLabel,
  getOptionValue,
}) => (
  <EditableFormPanel header={header} form={form} onSubmit={onSubmitRequest}>
    {(editable) => {
      const isEdit = !!initialValues
      return (
        <>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Full Name
            </Text>
            <FormInput
              name="sponsorFullName"
              placeholder="Sponsor Full Name"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Email
            </Text>
            <FormInput
              name="email"
              type="email"
              placeholder="Email"
              css={styles.control}
              disabled={!editable || isEdit}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Country
            </Text>
            <FormInput
              oldInput
              strictLong
              cacheOptions
              defaultOptions
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="country"
              placeholder="Select country"
              loadOptions={loadJurisdictions}
              disabled={!editable}
              styles={styles.select}
              bordered
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Website
            </Text>
            <FormInput
              name="website"
              placeholder="Website"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Logo
            </Text>
            <FormInput
              name="logo"
              placeholder="Put link to logo here"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Sponsor limit
            </Text>
            <FormInput
              name="sponsorLimit"
              placeholder="Sponsor Limit $"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Tax Id
            </Text>
            <FormInput
              name="taxId"
              placeholder="NNN-NN-NNNN"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.rowWithToggle}>
            <Text as="label" size={16}>
              Member status
            </Text>
            <FormInput
              oldInput
              name="active"
              type="toggle"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.rowWithToggle}>
            <Text as="label" size={16}>
              Marketing Promotion
            </Text>
            <FormInput
              oldInput
              name="marketingPromotion"
              type="toggle"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
        </>
      )
    }}
  </EditableFormPanel>
)

EditSponsorsFormComponent.propTypes = {
  form: PropTypes.shape(),
  header: PropTypes.string.isRequired,
  loadJurisdictions: PropTypes.func,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  initialValues: PropTypes.shape(),
  onSubmitRequest: PropTypes.func,
}

export default EditSponsorsFormComponent
